var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layer',{attrs:{"pagename":"schoolReport","pageClass":"schoolReportPage ks_page"}},[_c('div',{staticClass:"schoolReport"},[_c('div',{staticClass:"z_title"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.type=='prescription'?'百年方考核成绩':'病案历考核成绩'))])]),_c('Table',{attrs:{"stripe":"","columns":_vm.columns1,"data":_vm.list}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }